/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 定額契約値情報
 */
export interface Sgkb575aResFlatAmntConvalInfo {
    /** 
     * 契約個数：半角数字
     */
    ctrNum?: string;
}
